import { Crown } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const presetStyles: Record<string, string> = {
  Owner: 'bg-amber-100 text-amber-800 hover:bg-amber-100 border-amber-300',
  FullAdmin: 'bg-purple-100 text-purple-800 hover:bg-purple-100 border-purple-300',
  FieldDirector: 'bg-blue-100 text-blue-800 hover:bg-blue-100 border-blue-300',
  Volunteer: 'bg-gray-100 text-gray-700 hover:bg-gray-100',
  ViewOnly: 'bg-slate-100 text-slate-600 hover:bg-slate-100',
  Custom: 'bg-teal-100 text-teal-800 hover:bg-teal-100 border-teal-300',
};

const presetLabels: Record<string, string> = {
  Owner: 'Owner',
  FullAdmin: 'Full Admin',
  FieldDirector: 'Field Director',
  Volunteer: 'Volunteer',
  ViewOnly: 'View Only',
  Custom: 'Custom',
};

interface PresetBadgeProps {
  isOwner: boolean;
  presetKey: string | null;
  className?: string;
}

export function PresetBadge({ isOwner, presetKey, className }: PresetBadgeProps) {
  const key = isOwner ? 'Owner' : (presetKey ?? 'Custom');
  const style = presetStyles[key] || presetStyles.Custom;
  const label = presetLabels[key] || key;

  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium gap-1', style, className)}
    >
      {isOwner && <Crown className="h-3 w-3" />}
      {label}
    </Badge>
  );
}
